export default __webpack_public_path__ + "static/media/mail-envelope-green-icon.0b7b0ec3.svg";